import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild } from '@angular/core';
import { Contact } from 'src/classes/contact';
import { simplifySpecialCharacters } from '../../utils/simplifySpecialCharacters';

@Component({
  selector: 'app-contact-input',
  templateUrl: './contact-input.component.html',
  styleUrls: ['./contact-input.component.scss']
})
export class ContactInputComponent implements OnInit {
  @Input() contactList: Contact[] = [];
  @Input() startValues: Contact[] = [];
  @Output() contactChange = new EventEmitter<Contact[]>();

  public visibleList: Contact[] = [];
  public filteredList: Contact[] = [];
  public isFiltered = false;
  public selectList: Contact[] = [];
  public showOptions = false;
  public contactDropdownWidth = this.getContactDropdownWidth();

  @ViewChild('optionListGroup', { static: true }) optionListGroup;
  @ViewChild('input', { static: true }) input;

  constructor() { }

  ngOnInit() {
    if (!this.selectList) {
      this.selectList = [];
    }
    // Only add to selected the contacts which exists in the whole list
    this.selectList.push(...this.startValues.filter(contact => this.contactList.includes(contact)));
    // Only add to visible the contacts which are not added to selection
    this.visibleList.push(...this.contactList.filter(contact => !this.selectList.includes(contact)));
  }

  onSelectOption(option: Contact) {
    if (this.visibleList.includes(option)) {
      this.visibleList.splice(this.visibleList.indexOf(option), 1);
    }
    if (this.isFiltered) {
      this.updateFilteredList();
    }
    this.selectList.push(option);
    this.contactChange.emit(this.selectList);
  }

  onRemoveSelected(option: Contact) {
    if (this.selectList.includes(option)) {
      this.selectList.splice(this.selectList.indexOf(option), 1);
    }
    if (this.isFiltered && this.filteredList.includes(option)) {
      this.filteredList.splice(this.filteredList.indexOf(option), 1);
    }
    this.visibleList.push(option);
    this.contactChange.emit(this.selectList);
  }

  getContactDropdownWidth() {
    if (this.optionListGroup && this.optionListGroup.nativeElement) {
      const el = this.optionListGroup.nativeElement.querySelector(".option-list-wrapper");
      if (el) {
        return el.getBoundingClientRect().width - 2;
      }
    }
    return 240;
  }

  onInputFocus(isFocused: boolean) {
    if (isFocused) {
      const width = this.getContactDropdownWidth();
      if (this.contactDropdownWidth !== width) {
        this.contactDropdownWidth = width;
      }
    }
    this.showOptions = isFocused;
  }

  updateFilteredList() {
    const value = simplifySpecialCharacters(this.input.nativeElement.value.trim()).toLowerCase();
    this.isFiltered = (value !== '');
    this.filteredList = this.visibleList.filter((contact) => {
      if (simplifySpecialCharacters(contact.email).toLowerCase().includes(value)) {
        return true;
      } else if (simplifySpecialCharacters(contact.name).toLowerCase().includes(value)) {
        return true;
      }
      return false;
    }).filter((contact, i) => i < 5);
  }

  onInputChange() {
    this.updateFilteredList();
  }

  // Detect FocusOut via global click so that options don't dissapear on click
  @HostListener('window:click', ['$event'])
  onWindowClick(event) {
    if (this.showOptions && this.optionListGroup && this.optionListGroup.nativeElement) {
      if (this.input && this.input.nativeElement && document.activeElement === this.input.nativeElement) {
        return true;
      }
      let hasGroup = false;
      for (const element of event.composedPath()) {
        if (element && element.classList && element.classList.contains('option-list-group')) {
          hasGroup = true;
        }
      }
      if (!hasGroup) {
        this.onInputFocus(false);
      }
    }
  }

}
